<template>
  <div class="tab-panel-body">
    <!-- Header -->
    <div class="config-section-header">
      <div class="config-section-header__left">
        <v-icon small class="mr-2" color="text_secondary">mdi-alphabetical-off</v-icon>
        <span class="config-section-label">Palavras bloqueadas</span>
        <v-chip v-if="palavras_bloqueadas && palavras_bloqueadas.length" x-small class="ml-2" color="surface_tertiary">
          {{ palavras_bloqueadas.length }}
        </v-chip>
      </div>
      <ModalAdicionarOuEditarPalavraBloqueada
        :getPalavrasBloqueada="fetch"
      />
    </div>

    <!-- Table -->
    <DataTables
      v-if="palavras_bloqueadas && palavras_bloqueadas.length > 0"
      :data="palavras_bloqueadas"
      :headers="headers"
      :itens-por-pagina="5"
      :fetchData="fetch"
      tab="palavras"
      class="palavras-table"
    />

    <!-- Empty state -->
    <div v-if="palavras_bloqueadas && palavras_bloqueadas.length === 0" class="sc-empty-state">
      <v-icon size="40" color="text_secondary" class="mb-3">mdi-text-box-check-outline</v-icon>
      <span class="sc-empty-state__title">Nenhuma palavra bloqueada</span>
      <span class="sc-empty-state__subtitle">Adicione palavras para filtrar colaborações com conteúdo indesejado</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalAdicionarOuEditarPalavraBloqueada from "../../PalavraBloqueada/ModalAdicionarOuEditarPalavraBloqueada.vue";
import DataTables from "@/components/DataTables.vue";

export default {
  name: "ConfigTabPalavrasBloqueadas",
  components: { ModalAdicionarOuEditarPalavraBloqueada, DataTables },
  props: {
    codProducao: { type: Number, required: true },
    active: { type: Boolean, default: false },
  },
  watch: {
    active: {
      immediate: true,
      handler(isActive) {
        if (isActive) this.fetch();
      },
    },
    codProducao() {
      if (this.active) this.fetch();
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Palavra",
          align: "start",
          sortable: false,
          name: "dsc_palavra",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Ações",
          sortable: false,
          name: "actions",
          align: "end",
          class: "subtitle-1 font-weight-bold pr-15",
          value: "name",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      palavras_bloqueadas: "palavras_bloqueadas/getterPalavrasBloqueadas",
    }),
  },
  methods: {
    ...mapActions({
      getPalavrasBloqueadas: "palavras_bloqueadas/getPalavrasBloqueadas",
    }),
    async fetch() {
      await this.getPalavrasBloqueadas({ cod_producao: this.codProducao });
    },
  },
};
</script>

<style lang="scss" scoped>
.palavras-table {
  border-radius: var(--sc-radius-lg);
  overflow: hidden;
}

::v-deep .palavras-table tbody td {
  height: 72px !important;
}

</style>
